import styled from 'styled-components';
import {styledByDevice} from '../../../../../../../themes/architecture/styled-by-device';
import { Image } from '../../../../../../raw-components/image/image';


//.info-image-wrapper + info-image

const DefaultBox = styled(Image)`
    display: block;
    width: 100%;
    height: 100%;
    margin-bottom: 1.1rem;
`;

const PcBox = styled(DefaultBox)`
    width: 375px;
    height: 121px;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      width: 285px;
      height: 92px;
   }
`;

const MobileBox = styled(DefaultBox)`
    opacity: 0.7;
`;

export const StripeImageDefaultBox = styledByDevice(PcBox, MobileBox);